<template>
  <div class="view">
    <div class="content">
      <div class="block" v-intersection="handler"></div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    handler(entries) {
      console.log(entries);
    },
  },
};
</script>
<style lang="css" scoped>
.view {
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: white;
}

.content {
  width: 100vw;
  height: 300vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.block {
  width: 10vh;
  height: 10vh;
  background-color: #2278cf;
  border-radius: 20px;
}
</style>
